import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
// import PropTypes from "prop-types";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";

function Modalcustomer(props) {
    var { isOpenModalCustomer, openModal } = props;
    var { name, phone_number, address_detail, address_line2, district_info, postal_code, delivery_preferences } = props.customer;
    const { t } = useTranslation();

    const onOpenModal = () => {
        openModal();
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={() => { onOpenModal() }} isOpen={isOpenModalCustomer}>
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Customer")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <strong>{name}</strong> - {phone_number}<br />
                    {address_detail}, {address_line2 ? address_line2 + ", " : ""} {district_info?.[3]?.address_name ? district_info?.[3]?.address_name + ", " : ""} {district_info?.[2]?.address_name && district_info?.[2]?.address_level_name !== "County" ? district_info?.[2]?.address_name + ", " : ""} {district_info?.[1]?.address_name ? district_info?.[1]?.address_name + ", " : ""} {district_info?.[0]?.address_name ? district_info?.[0]?.address_name + ", " : ""} {postal_code ? postal_code : ""}
                    {delivery_preferences?.drop_off_location && delivery_preferences?.drop_off_location !== "" ? <><br /><strong>Delivery instructions:</strong>{delivery_preferences?.drop_off_location}</> : ""}
                </ModalBody>
                <ModalFooter>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

// Modalcustomer.propTypes = {
// };
const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Modalcustomer);